import React from 'react';

const OffersSection = () => {
  const offers = [
    {
      id: 1,
      title: "Flat 5% Off",
      description: "5% Off on your monthly rentals.",
      couponCode: "BPSALE5",
      icon: "🎯"
    },
    {
      id: 2,
      title: "Flat 10% Off",
      description: "10% Off on your monthly rentals.",
      couponCode: "BPSALE10",
      icon: "⭐"
    },
    {
      id: 3,
      title: "Flat 75% Off",
      description: "Flat 75% off on your rent on 6th and 12th month of your rental period.",
      couponCode: "2BPSALE75",
      icon: "🔥"
    },
    {
      id: 4,
      title: "Flat 50% Off",
      description: "Flat 50% off on your rent on 6th and 12th month of your rental period.",
      couponCode: "2BPSALE50",
      icon: "💎"
    }
  ];

  return (
    <section className="py-8 lg:py-24 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 lg:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-bold text-gray-800 mb-2 lg:mb-4">
            Offers & Discounts
          </h2>
          <p className="text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">
            Unlock amazing savings on your furniture rentals with our exclusive offers
          </p>
        </div>

        {/* Offers Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8">
          {offers.map((offer) => (
            <div
              key={offer.id}
              className="relative group bg-white rounded-xl lg:rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100 overflow-hidden"
            >
              {/* Background Pattern */}
              <div className="absolute inset-0 opacity-5">
                <div className="absolute top-2 lg:top-4 right-2 lg:right-4 w-8 lg:w-16 h-8 lg:h-16 bg-gray-300 rounded-full"></div>
                <div className="absolute bottom-3 lg:bottom-8 left-3 lg:left-8 w-4 lg:w-8 h-4 lg:h-8 bg-gray-300 rounded-full"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 lg:w-24 h-0.5 lg:h-1 bg-gray-300 rotate-45"></div>
              </div>

              {/* Card Content */}
              <div className="relative z-10 p-4 lg:p-8">
                {/* Icon and Title */}
                <div className="flex items-center mb-3 lg:mb-4">
                  <div className="w-10 h-10 lg:w-12 lg:h-12 bg-gradient-to-r from-gray-900 to-gray-800 rounded-lg lg:rounded-xl flex items-center justify-center mr-3 lg:mr-4 shadow-md">
                    <span className="text-white text-lg lg:text-xl">{offer.icon}</span>
                  </div>
                  <h3 className="text-lg lg:text-2xl font-bold text-gray-800">
                    {offer.title}
                  </h3>
                </div>

                {/* Description */}
                <p className="text-gray-600 text-sm lg:text-base mb-4 lg:mb-6 leading-relaxed">
                  {offer.description}
                </p>

                {/* Coupon Code */}
                <div className="bg-gradient-to-r from-gray-100 to-gray-200 rounded-lg lg:rounded-xl p-3 lg:p-4 border border-gray-200">
                  <div className="flex items-center justify-between">
                    <span className="text-xs lg:text-sm text-gray-600 font-medium">Coupon Code:</span>
                    <span className="text-sm lg:text-lg font-bold text-gray-800 bg-white px-2 lg:px-3 py-1 rounded-lg shadow-sm">
                      {offer.couponCode}
                    </span>
                  </div>
                </div>

                {/* Hover Effect Overlay */}
                <div className="absolute inset-0 bg-gradient-to-r from-gray-900 to-gray-800 opacity-0 group-hover:opacity-10 transition-opacity duration-300 rounded-xl lg:rounded-2xl"></div>
              </div>

              {/* Corner Accent */}
              <div className="absolute top-0 right-0 w-8 lg:w-16 h-8 lg:h-16 bg-gradient-to-br from-gray-900 to-gray-800 opacity-10 group-hover:opacity-20 transition-opacity duration-300 rounded-bl-xl lg:rounded-bl-2xl"></div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-8 lg:mt-16">
          <button className="bg-gradient-to-r from-gray-900 to-gray-800 text-white px-6 lg:px-8 py-3 lg:py-4 rounded-lg lg:rounded-xl text-base lg:text-lg font-semibold hover:from-gray-800 hover:to-gray-700 transform hover:scale-105 transition-all duration-200 shadow-lg hover:shadow-xl">
            View All Offers
          </button>
        </div>
      </div>
    </section>
  );
};

export default OffersSection; 